export default {
  getters: {
    isHome (state, getters, rootState) {
      return rootState.route.name === `${rootState.i18n.locale}.home`
    },
    isContent (state, getters, rootState) {
      return rootState.route.name === `${rootState.i18n.locale}.content`
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/router.js